import { mapActions } from "vuex";
import { defineAsyncComponent } from 'vue';
import FlyModal from "@/toremove/components/octolo/modals/Fly.vue";

export default {
    data(){ return {
        modals: [],
    }},
    components: {
        FlyModal, //async error for visio
        Modal: defineAsyncComponent(() => import("@/toremove/components/octolo/modals/Basic.vue")),
        OctoloModal: defineAsyncComponent(() => import("@/toremove/components/octolo/modals/Modal.vue")),
    },
    methods: {
        ...mapActions('App', ['openModalURL', 'closeModalURL']),
        openModal(modal){ this.modals[modal] = true; },
        closeModal(modal){ this.modals[modal] = false; },
    },
}